export const OrderByEnum = {
    ASC: "asc",
    DESC: "desc"
}